import { Link } from "react-router"
import { getAPIHeaders, getAPIMultiPartHeaders } from "../../common/Utils";
import ImageWithBasePath from "./imageWithBasePath";
import { useEffect, useState } from "react";
import useFetch from "../../hooks/useFetch";
import { API } from "../../common/Constants";
import PreLoader from "./preLoader";

interface Props {
    id?: number
}
const DEFAULT_PROFILE_PIC = "assets/img/users/user-13.jpg";
const MAX_SIZE = 4 * 1024 * 1024;

const ProfilePic = ({ id }: Props) => {
    const { isLoading, error, callFetch } = useFetch();
    const [image, setImage] = useState<any>(null);
    const [imagePreview, setImagePreview] = useState(DEFAULT_PROFILE_PIC);
    const [profileID, setProfileID] = useState<number>();
    const [errorMessage, setErrorMessage] = useState<string>("")
    const [uploadInProgress, setUploadInProgress] = useState<boolean>(false)

    useEffect(() => {
        setUploadInProgress(false)
        setErrorMessage("")
        setProfileID(id)
        fetchProfilePic()
    }, [id])

    useEffect(() => {
        if(uploadInProgress && error){
            if(error.response?.data){
              setErrorMessage(error.response?.data)
            } else{
              setErrorMessage('Something went wrong please try again later.')
            }
          }
    }, [error]);

    const handleImageChange = (e: any) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };



    const profilePicCancel = () => {
        setImage(null);
        setImagePreview("");
        setErrorMessage("")
    }

    const uploadProfilePic = (event: any) => {
        event.preventDefault()
        if (!image) {
            setErrorMessage("Please select an image to upload")
        } else if (image.size > MAX_SIZE){
            setErrorMessage("Image size should be less than 4mb")
        }else if (image) {
            setErrorMessage("")
            const formData = new FormData();
            formData.append('file', image);
            setUploadInProgress(true)
            callFetch(`${API.PROILE_IMG}`,
                'PUT',
                getAPIMultiPartHeaders(),
                null,
                formData
            ).catch((err) => {
                setErrorMessage('Failed to upload image');
                setUploadInProgress(false);
            });
        }
    }

    const fetchProfilePic = () => {
        if(id){
            callFetch(`${API.PROILE_IMG}`,
                'GET',
                getAPIHeaders(),
                null,
                null
            ).then((res)=>{
                if(res && res.fileUrl){
                    setImagePreview(res.fileUrl)
                } else {
                    setImagePreview(DEFAULT_PROFILE_PIC)
                }
            }).catch(()=>{
                setImagePreview(DEFAULT_PROFILE_PIC)
            });
        }
    }


    return (
        <>
            <PreLoader showLoader={isLoading} />
            <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                    <ImageWithBasePath
                        src={imagePreview || DEFAULT_PROFILE_PIC}
                        alt="img"
                        className="rounded-circle"
                    />
                </div>
                <div className="profile-upload">
                    <div className="mb-2">
                        <h6 className="mb-1">Upload Profile Image</h6>
                        <p className="fs-12">Image should be below 4 mb</p>
                    </div>
                    <div className="profile-uploader d-flex align-items-center">
                        <div className="drag-upload-btn btn btn-sm btn-secondary me-2">
                            Select
                            <input
                                type="file"
                                className="form-control image-sign"
                                multiple
                                onChange={handleImageChange}
                            />
                        </div>
                        <button className='btn btn-sm btn-primary me-2'
                            onClick={uploadProfilePic}
                            disabled={profileID ? false : true}>
                            Upload
                        </button>
                        <Link
                            to="#"
                            className="btn btn-light btn-sm"
                            onClick={profilePicCancel}
                        >
                            Cancel
                        </Link>
                    </div>
                    <div className="mt-2 text-danger">
                        {
                            errorMessage
                                ?
                                <><i className="ti ti-alert-triangle" /> {errorMessage} </>
                                :
                                <></>}
                    </div>
                </div>
            </div>
        </>

    )
}

export default ProfilePic